import { render, staticRenderFns } from "./StockDispatchItem.vue?vue&type=template&id=0e8a0281&"
import script from "./StockDispatchItem.vue?vue&type=script&lang=js&"
export * from "./StockDispatchItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StockDispatchItem.vue"
export default component.exports